"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGlobalProxyAgent", {
  enumerable: true,
  get: function () {
    return _createGlobalProxyAgent.default;
  }
});
Object.defineProperty(exports, "createProxyController", {
  enumerable: true,
  get: function () {
    return _createProxyController.default;
  }
});

var _createGlobalProxyAgent = _interopRequireDefault(require("./createGlobalProxyAgent"));

var _createProxyController = _interopRequireDefault(require("./createProxyController"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map